document.addEventListener('click', function (event) {
  var target = event.target;
  if (!target || typeof target.closest !== 'function') return;

  var trigger = target.closest('.calendly-button a[href]');
  if (!trigger || typeof window.Calendly === 'undefined') return;

  event.preventDefault();
  window.Calendly.initPopupWidget({ url: trigger.href });
});
